export default "__VITE_ASSET__c1d01d78__"